
 const paymentMethodTypesEfileTypeNmiReducer = (state = [], action) => {
  switch (action.type) {
    case 'LANDSHARK_PAYMENT_METHOD_TYPES_EFILE_TYPE_NMI':
      return action.results;
    default:
      break;
  }
  return state;
}

export default paymentMethodTypesEfileTypeNmiReducer;